import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { useEffect, useState } from "react";
import { Loader } from "../../loaders/Loader";
import { DataTable } from "primereact/datatable";
import { getBasicTableBasicBody, getDateTimeTableBody } from "../../tablesShared/tableTools/tableCellBodies";
import { useFetchDrivewaysByTransportIdQuery } from "../../../api/rtk/base/slices/transportApiSlice";
import { useLocation, useParams } from "react-router-dom";
import { thousandSeparator } from "../../../features/dataFormatFunctions/dataFormatter";
import ToastMessageContainer from "../../toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from "../../../stateManagement/reducers";

function prepareTransportHistoryTableValue(value: any) {
    let newValue: any = []
    value.map((item: any) => {
        let newItem: any = {}
        Object.keys(item).map((key) => {
            let newFieldValue;
            if (key === 'startPosition' || key === 'endPosition') {
                newFieldValue = thousandSeparator(parseFloat(item[key]).toFixed(3)?.toString()?.replace('-0.000', '0.000'))
            }
            else if (key === 'avgSpeed') {
                newFieldValue = thousandSeparator(parseFloat(item[key]).toFixed(2)?.toString()?.replace('-0.000', '0.000'))
            }
            else {
                newFieldValue = item[key]
            }
            newItem[key] = newFieldValue
        })
        // заполняем новый массив данных
        newValue.push(newItem)
    })
    return newValue
}

// Шаблон колонок для таблицы покрытия типов дорожных одежд
const transportHistoryColumns: any = [
    {
        headerName: "Наименование дороги",
        pdfHeader: "Наименование дороги",
        field: "roadName",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Направление",
        pdfHeader: "Направление",
        field: "pathName",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Въезд",
        pdfHeader: "Время въезда",
        field: "startDate",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Выезд",
        pdfHeader: "Время выезда",
        field: "endDate",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Начало",
        pdfHeader: "Начало",
        field: "startPosition",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Конец",
        pdfHeader: "Конец",
        field: "endPosition",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Ср. скорость",
        pdfHeader: "Ср. скорость",
        field: "avgSpeed",
        valueType: "float",
        width: 100,
        align: "center"
    },
]

export default function TransportHistoryObjectDrivewaysTable() {
    const { transportId } = useParams()
    const dispatch = useDispatch()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search);
    const lon = searchParams.get('lon');
    const lat = searchParams.get('lat');
    const date = searchParams.get('date');

    const {
        data: transportDriveways,
        isFetching: transportDrivewaysAreFetching,
        isError: isErrorTransportDriveways
    } = useFetchDrivewaysByTransportIdQuery({ lon, lat, transportId: transportId, date })

    const [tableValue, setTableValue] = useState<any>(null)

    useEffect(() => {
        if (transportDriveways) {
            setTableValue(prepareTransportHistoryTableValue(transportDriveways.driveways))
        }
    }, [transportDriveways])

    let headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Наименование дороги" rowSpan={2} align="center" />
                <Column header="Направление" rowSpan={2} align="center" />
                <Column header="Время" colSpan={2} align="center" />
                <Column header="Адрес, км" colSpan={2} align="center" />
                <Column header="Ср. скорость" rowSpan={2} align="center" />
            </Row>
            <Row>
                <Column header="Въезд" colSpan={1} align="center" />
                <Column header="Выезд" colSpan={1} align="center" />
                <Column header="Начало" colSpan={1} align="center" />
                <Column header="Конец" colSpan={1} align="center" />
            </Row>
        </ColumnGroup>
    );

    useEffect(() => {
        if (transportDrivewaysAreFetching) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [transportDrivewaysAreFetching])

    useEffect(() => {
        if (isErrorTransportDriveways) {
            dispatch(showToastMessage({ messageText: "Не удалось загрузить транспортные маршруты", messageType: "error" }))
        }
    }, [isErrorTransportDriveways])

    return (
        <div className="table-wrap table-wrap-under-map">
            <ToastMessageContainer />
            {transportDrivewaysAreFetching
                ?
                <Loader />
                :
                <DataTable
                    value={tableValue}
                    scrollable
                    size="normal"
                    removableSort
                    selectionMode="single"
                    dataKey="id"
                    loadingIcon={<Loader />}
                    headerColumnGroup={headerGroup}
                    scrollHeight="calc(100% - 22px)"
                    emptyMessage="Данных нет">
                    {/* Столбцы таблицы */}
                    {transportHistoryColumns?.map((item: any, idx: any) => (
                        <Column
                            key={idx}
                            field={item.field}
                            sortable={item.canBeSorted}
                            header={item.header ? item.header : item.headerName}
                            hidden={item?.hidden}
                            align={item.align}
                            dataType={(item.valueType === "float" || item.valueType === "int") ? "numeric" : undefined}
                            body={(rowData: any) => (item.field === 'startDate' || item.field === 'endDate') ? getDateTimeTableBody(rowData, item.field) : getBasicTableBasicBody(rowData, item.field)}
                        >
                        </Column>
                    ))}
                </DataTable>
            }
        </div>
    )
}
